/**
 * 轮播控制器
 * */
import sdkTool from "If_AdTool/common/sdkTool";
function adRotatorFactory(RotatorConfig){
    if (typeof(RotatorConfig.saleMode) != "undefined") {
        var saleMode = RotatorConfig.saleMode
    } else {
        saleMode = "CPD";
    }
    if (saleMode == "CPD") {
        new AdRotator(RotatorConfig)
    } else if (saleMode == "CPT"){
        new HourAdRotator(RotatorConfig)
    }
}
function AdRotator (RotatorConfig) {
    var cookieFlag = "ifengRotator_" + RotatorConfig.apid;
    var maxTimes = RotatorConfig.maxTimes;
    var current = sdkTool.cookie(cookieFlag);
    var currentData = {};
    RotatorConfig.data.ap?currentData.ap=RotatorConfig.data.ap:null;
    RotatorConfig.data.extra?currentData.extra = RotatorConfig.data.extra:null;
    if (typeof(current) === "undefined" || current === "" || current == "NaN") {
        current = parseInt(Math.random() * 100000) % maxTimes
    }
    sdkTool.cookie(cookieFlag, ((parseInt(current) + 1) % maxTimes));
    // ????
    if(RotatorConfig.data&&RotatorConfig.data.lists){
        var dataSource = RotatorConfig.data.lists;
        var dataForRotator = [];
        var dataForBase = [];
        for(var i=0;i<dataSource.length;i++){
            if(dataSource[i].base&&dataSource[i].base=="ture"){
                dataForBase.push(dataSource[i])
            }else{
                dataForRotator.push(dataSource[i])
            }
        }
    }
    // ????
    if (dataForRotator[current]) {
        for(let key in dataForRotator[current]){
            currentData[key]=dataForRotator[current][key];
        }   
    }else if(dataForBase[0]){
        for(let key in dataForBase[0]){
            currentData[key]=dataForBase[0][key];
        }
    }
    RotatorConfig.handler&&RotatorConfig.handler(RotatorConfig.elm,currentData);
    
};
function HourAdRotator(RotatorConfig) {
}


export default adRotatorFactory;